<template>
    <el-card class="full-width-card" shadow="always" :body-style="{padding: '10px'}" v-loading="loading">
        <ul class="card-ul">
            <li>
                <h4>{{recordname}}</h4>
            </li>
			
			<li class="img-part" v-if="null != imgUrl">
                <div class="hall-img-box">
                    <img :src="imgUrl">
                </div>
            </li>
			
            <li class="info-part">
                <span class="icon-span"><font-awesome-icon icon="fa-solid fa-location-dot" /></span>&nbsp;<span>{{countryname}}</span>
            </li>

<!--            <li class="info-part">-->
<!--                <span tkey="參展費用">{{i18n.tkey("lang_join_hall_cost")}}</span> : <span>{{obj.additionalrecord14.addinfo9}} HKD</span>-->
<!--            </li>-->

            <li class="info-part">
                <span tkey="主辦方">{{i18n.tkey("lang_sponsor")}}</span> : <span>{{companyname}}</span>
            </li>

            <li class="info-part" v-if="queryType == 0">
                <span tkey="報名時間">{{i18n.tkey("lang_entry_time")}}</span> : <span>{{obj.additionalrecord14.addinfo1}} - {{obj.additionalrecord14.addinfo2}}</span>
            </li>

            <li class="info-part" v-if="queryType == 0">
                <span tkey="開放時間">{{i18n.tkey("lang_open_time")}}</span> : <span>{{obj.additionalrecord14.addinfo3}} - {{obj.additionalrecord14.addinfo4}}</span>
            </li>

            <li class="des-part" v-if="queryType == 0">
                <span tkey="展館描述">{{i18n.tkey("lang_hall_des")}}</span> : <span>{{addinfo7}}</span>
            </li>

            <li class="des-part" v-if="queryType != 0">
                <span tkey="描述">{{i18n.tkey("lang_des")}}</span> : <span>{{addinfo7}}</span>
            </li>

            <li class="operation-box">
                <div v-if="queryType == 0">
                    <el-button @click="clickPay" type="primary" v-if="obj.recordno == 0" tkey="支付">{{i18n.tkey("lang_pay_1")}}</el-button>
                    <el-button @click="clickViewBtn" tkey="查看" >{{i18n.tkey("lang_check")}}</el-button>
                    <el-button v-if="obj.recordno == -1" @click="clickEditBtn" type="primary" plain tkey="展位管理">{{i18n.tkey("lang_hall_position_manager")}}</el-button>
                    <el-button v-if="obj.recordno == -1" @click="clickProductBtn" type="primary" plain tkey="參展產品">{{i18n.tkey("lang_exhibited_products")}}</el-button>
                </div>

                <div v-if="queryType != 0">
                    <el-button @click="clickGoViewBtn" tkey="查看" >{{i18n.tkey("lang_check")}}</el-button>
                </div>

            </li>
        </ul>

        <paypalForm v-if="null != rePayObj" :formObj="rePayObj" @submit-complete="submitComplete" />
    </el-card>
</template>

<script setup>

    import {computed, inject, ref, toRef, onBeforeMount, getCurrentInstance} from "vue";
    import paypalForm from "@/components/shopopee/form/paypalForm"
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
    import {useUserinfo} from "@/stores/userinfo";
	import myUtil from "@/util/util";

    library.add(faLocationDot)

    const i18n = inject("i18n")
    const userInfoRef = toRef(useUserinfo())

    const props = defineProps(["obj", "type"])
    const emits = defineEmits(["clickView", "clickEdit", "clickProduct"])

    const loading = ref(false)
    const { proxy } = getCurrentInstance()

    //需要重新付款的订单
    const rePayObj = ref(null)
    //記錄類別
    const queryType = ref(0)

    const reload = inject("reload");

    const recordname = computed(() => {
        let name = props.obj.additionalrecord14.recordname

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
            name = props.obj.additionalrecord14.addinfo6
        }

        return name
    })

    const addinfo7 = computed(() => {
        let name = props.obj.additionalrecord14.addinfo7

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
            name = props.obj.additionalrecord14.addinfo8
        }

        return name
    })

    const companyname = computed(() => {
        let name = "3DShopopee"

        if (myUtil.isNotEmpty(props.obj.additionalrecord14.companyname) && props.obj.additionalrecord14.companycode !== "ZZ"){
            name = props.obj.additionalrecord14.companyname

            if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
                name = props.obj.additionalrecord14.companyname2
            }
        }

        return name
    })

    const countryname = computed(() => {
        let name = props.obj.country.countryname

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
            name = props.obj.country.countryname2
        }

        return name
    })

    function clickViewBtn() {
        emits("clickView", props.obj)
    }

    function clickEditBtn() {
        emits("clickEdit", props.obj)
    }

    function clickPay() {
        loading.value = true
        rePayObj.value = {
            fromtitle: "shopopee_exhibition_" + props.obj.addinfo11,
            fromnumber: props.obj.addinfo11,
            fromamout: props.obj.additionalrecord14.addinfo9,
            fromcurr: "HKD"
        }
    }

    function submitComplete() {
        loading.value = false
        rePayObj.value = null
    }
	const imgUrl = computed(() => {
		let url = props.obj.additionalrecord14.addinfo11
		
		if(userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
			url = props.obj.additionalrecord14.addinfo12
			if(myUtil.isEmpty(url)){
				url = props.obj.additionalrecord14.addinfo11
			}
		}
		
		return url
	})

    function clickProductBtn(){
        emits("clickProduct")
    }

    function clickGoViewBtn(){
        proxy.$router.push({
            path: `/hall/${props.obj.additionalrecord14.id}/${props.obj.addinfo1}/${props.obj.addinfo2}`
        })

        if (proxy.$route.path.indexOf("/hall") != -1){
            reload()
        }
    }

    onBeforeMount(() => {
        if (null != props.type){
            queryType.value = props.type
        }
    })

</script>

<style scoped>
    .full-width-card {
        width: 100%;
    }

    .card-ul {
        list-style: none;
        padding-left: 0;
        text-align: left;
    }

    .operation-box {
        text-align: center;
        margin-top: 15px;
    }

    .info-part {
        line-height: 2;
        color: #606266;
    }

    .des-part {
        height: 4.5em;
        line-height: 1.5;
        overflow: hidden;
        color: #606266;
    }

    .icon-span {
        color: #79bbff;
    }
	
	.additionlrecord14-img{
		width: 100%;
	}

    .img-part .hall-img-box {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        padding-top: 50%;
    }

    .img-part .hall-img-box img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: fill;
        top: 0;
        left: 0;
        border: 1px #E4E7ED solid;
    }
</style>